<template>
  <div class="flex items-center justify-between gap-3 rounded-md border border-input/70 px-3 py-2">
    <div class="min-w-0">
      <p class="truncate text-sm font-medium">
        {{ displayFilename }}
      </p>
      <div class="flex flex-wrap items-center gap-2">
        <Badge variant="outline" class="text-xs">
          {{ assetTypeLabel }}
        </Badge>
        <Badge :variant="isIndexed ? 'default' : 'secondary'" class="text-xs">
          {{ isIndexed ? 'Indexed' : 'Pending index' }}
        </Badge>
        <span class="text-xs text-muted-foreground">
          {{ uploadedAtLabel }}
        </span>
      </div>
    </div>

    <Button size="xs" variant="destructive" :disabled="isDeleting" @click="handleDelete">
      {{ isDeleting ? 'Deleting...' : 'Delete' }}
    </Button>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { Badge } from '../../../../../../../resources/js/components/ui/badge/index.js'
import { Button } from '../../../../../../../resources/js/components/ui/button/index.js'


const props = defineProps({
  asset: {
    type: Object,
    required: true,
  },
  isDeleting: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(['delete'])

const displayFilename = computed(() => {
  const filename = props.asset?.upload?.filename

  if (typeof filename === 'string' && filename.trim() !== '') {
    return filename
  }

  return `Asset #${props.asset?.id ?? 'Unknown'}`
})

const assetTypeLabel = computed(() => {
  const type = String(props.asset?.type ?? '').trim()

  if (type === '') {
    return 'Reference'
  }

  return `${type.charAt(0).toUpperCase()}${type.slice(1)}`
})

const uploadedAtLabel = computed(() => {
  const timestamp = props.asset?.upload?.created_at ?? props.asset?.created_at
  const parsedTimestamp = Date.parse(String(timestamp ?? ''))

  if (Number.isNaN(parsedTimestamp)) {
    return 'Uploaded recently'
  }

  return new Date(parsedTimestamp).toLocaleString()
})

const isIndexed = computed(() => {
  return Boolean(props.asset?.indexed)
})

const handleDelete = () => {
  const shouldDelete = confirm(`Delete ${displayFilename.value} from this business system?`)

  if (!shouldDelete) {
    return
  }

  emit('delete', props.asset)
}
</script>
